import "./onboardingSteps.scss";

export enum PageModeOnboarding {
    ONBOARDING,
    MERCHANT_NUMBER,
    SECURITY_QUESTION,
    ONBOARDING_RESULT,
    RESET_PASSWORD,
    OTP_ACTIVATE_DEVICE
}

export enum PageActivateSteps {
    CONFIG,
    QR_SCAN,
    FIRST_CODE,
    SECOND_CODE
}

interface IProps {
    pageMode: PageModeOnboarding;

}

const StepProgress: React.FC<IProps> = ({ pageMode }: IProps) => {
    const stepKeys = Object.keys(PageModeOnboarding).filter(key => isNaN(Number(key))); // Listado de PageMode

    return (
        <div className="step-progress">
            <div className="steps">
                {stepKeys.map((label, index) => (
                    <div
                        key={label}
                        className={`step ${index <= pageMode ? 'active' : ''}`}
                    >
                    </div>
                ))}
            </div>
            <div className="step-label">
                {
                    pageMode === PageModeOnboarding.OTP_ACTIVATE_DEVICE ?
                    `Último paso` :
                    `Paso `+ (pageMode+1)
                }
            </div>
        </div>
    );
};
export default (StepProgress)